import { createReducer } from "redux-create-reducer";

import { UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS } from "../types";

const initialState = {
  isLoading: false,
};

const updateWatchListEntryEuTerroristReducer = createReducer(initialState, {
  [UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

export default updateWatchListEntryEuTerroristReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/reducers/updateWatchListEntryEuTerroristReducer.js